import React, { Component } from 'react';

//import { DIMENSIONS } from 'services/layoutManager';

//import { RESOLUTIONS } from 'services/config';
import TicketHistory from '../../blox_components/Support/TicketHistory/TicketHistory';

// const LAYOUT_CONFIG = {
// 	[RESOLUTIONS.LOW]: {
// 		ticketHistory: { x: 0, y: 0, dim: DIMENSIONS.TWO_BY_TEN, customHeight: 50 },
// 	},
// 	[RESOLUTIONS.MED]: {
// 		ticketHistory: { x: 2.5, y: 0, dim: DIMENSIONS.TWO_BY_EIGHT, customHeight: 50 },
// 	},
// 	[RESOLUTIONS.HIGH]: {
// 		ticketHistory: { x: 3, y: 0, dim: DIMENSIONS.TWO_BY_TEN, customHeight: 50 },
// 	},
// };
class TicketHistoryPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			error: false,
		};
	}
	render() {
		const { breakpoint, match, setModalContent, navigate, location } = this.props;
		//const columnCount = BREAKPOINT_COLCOUNT_MAP[breakpoint];
		return (
			<TicketHistory
				match={match}
				setModalContent={setModalContent}
				breakpoint={breakpoint}
				navigate={navigate}
				location={location}
			/>
		);
	}
}
export default TicketHistoryPage;
